module.exports = __webpack_public_path__ + "static/media/myco.3a8e9b68.webp";